export default "__VITE_ASSET__DIG8WPqQ__"